import solicitudes from './solicitudes.js';
import { getApi } from '../config/getApiUrl';

// ─── VENCIMIENTOS ────────────────────────────────────────────
export const getVencimientos = (id_usuario, dias = 30) =>
    solicitudes.fetchRegistrosAuth(`/vencimientos/${id_usuario}?dias=${dias}`);

export const actualizarVencimiento = (id_producto, id_usuario, datos) =>
    solicitudes.patchRegistroAuth(`/vencimientos/producto/${id_producto}/${id_usuario}`, datos);

// ─── ARQUEO DE CAJA ──────────────────────────────────────────
export const registrarArqueo = (id_usuario, datos) =>
    solicitudes.postRegistroAuth(`/arqueo-caja/registrar/${id_usuario}`, datos);

export const getHistorialArqueo = (id_usuario, limite = 20) => {
    return solicitudes.fetchRegistrosAuth(`/arqueo-caja/${id_usuario}?limite=${limite}`);
};

export const getHistorialArqueoPorSucursal = (id_sucursal, limite = 20) =>
    solicitudes.fetchRegistrosAuth(`/arqueo-caja/sucursal/${id_sucursal}?limite=${limite}`);

export const getCajerosSucursal = (id_usuario) =>
    solicitudes.fetchRegistrosAuth(`/arqueo-caja/cajeros/${id_usuario}`);

export const getPreviewArqueo = (id_usuario, id_cajero, periodo_inicio, periodo_fin) =>
    solicitudes.fetchRegistrosAuth(`/arqueo-caja/preview/${id_usuario}?id_cajero=${id_cajero}&periodo_inicio=${periodo_inicio}&periodo_fin=${periodo_fin}`);

export const getReporteTurno = (id_arqueo) =>
    solicitudes.fetchRegistrosAuth(`/arqueo-caja/reporte-turno/${id_arqueo}`);

// ─── COTIZACIONES ────────────────────────────────────────────
export const getCotizaciones = (id_usuario, estado = '') =>
    solicitudes.fetchRegistrosAuth(`/cotizaciones/${id_usuario}${estado ? `?estado=${estado}` : ''}`);

export const crearCotizacion = (id_usuario, datos) =>
    solicitudes.postRegistroAuth(`/cotizaciones/crear/${id_usuario}`, datos);

export const getDetalleCotizacion = (id_cotizacion) =>
    solicitudes.fetchRegistrosAuth(`/cotizaciones/detalle/${id_cotizacion}`);

export const actualizarEstadoCotizacion = (id_cotizacion, estado) =>
    solicitudes.patchRegistroAuth(`/cotizaciones/estado/${id_cotizacion}`, { estado });

// ─── DEVOLUCIONES ────────────────────────────────────────────
export const getDevoluciones = (id_usuario, sucursal = '') =>
    solicitudes.fetchRegistrosAuth(`/devoluciones/${id_usuario}${sucursal ? `?sucursal=${sucursal}` : ''}`);

export const getNCDisponibles = (id_usuario) =>
    solicitudes.fetchRegistrosAuth(`/devoluciones/disponibles/${id_usuario}`);

export const crearDevolucion = (id_usuario, datos) =>
    solicitudes.postRegistroAuth(`/devoluciones/crear/${id_usuario}`, datos);

export const getItemsVenta = async (identificador, fecha = '') => {
    const qs = fecha ? `?fecha=${fecha}` : '';
    const url = `${getApi()}/devoluciones/items-venta/${encodeURIComponent(identificador)}${qs}`;
    const token = localStorage.getItem('auth');
    const res = await fetch(url, { headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' } });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || `Error ${res.status}`);
    return data;
};

export const buscarNC = (numero, id_usuario) =>
    solicitudes.fetchRegistrosAuth(`/devoluciones/buscar-nc/${encodeURIComponent(numero)}/${id_usuario}`);

export const getHistorialNC = (id_usuario, sucursal = '') =>
    solicitudes.fetchRegistrosAuth(`/devoluciones/historial-nc/${id_usuario}${sucursal ? `?sucursal=${sucursal}` : ''}`);

export const getRetornos = (id_usuario) =>
    solicitudes.fetchRegistrosAuth(`/devoluciones/retornos/${id_usuario}`);

export const resolverRetorno = (id, id_usuario, destino, notas = '') =>
    solicitudes.patchRegistroAuth(`/devoluciones/retornos/${id}/resolver/${id_usuario}`, { destino, notas });

// ─── NÓMINA ──────────────────────────────────────────────────
export const getNomina = (id_usuario, params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return solicitudes.fetchRegistrosAuth(`/nomina/${id_usuario}${qs ? '?' + qs : ''}`);
};

export const getEmpleadosNomina = (id_usuario) =>
    solicitudes.fetchRegistrosAuth(`/nomina/empleados/${id_usuario}`);

export const calcularNomina = (id_usuario, datos) =>
    solicitudes.postRegistroAuth(`/nomina/calcular/${id_usuario}`, datos);

export const marcarNominaPagada = (id_nomina, id_usuario) =>
    solicitudes.patchRegistroAuth(`/nomina/pagar/${id_usuario}/${id_nomina}`, {});

export const previewNomina = (salario_bruto, otras_deducciones = 0) =>
    solicitudes.fetchRegistrosAuth(`/nomina/preview/calculo?salario_bruto=${salario_bruto}&otras_deducciones=${otras_deducciones}`);

// ─── PLANILLA ────────────────────────────────────────────────
export const getEmpleadosPlanilla = (id_usuario) =>
    solicitudes.fetchRegistrosAuth(`/planilla/empleados/${id_usuario}`);

export const getPlanilla = (id_usuario, params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return solicitudes.fetchRegistrosAuth(`/planilla/${id_usuario}${qs ? '?' + qs : ''}`);
};

export const getPlanillaPorSucursal = (id_usuario, id_sucursal, params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return solicitudes.fetchRegistrosAuth(`/planilla/sucursal/${id_usuario}/${id_sucursal}${qs ? '?' + qs : ''}`);
};

export const crearPagoPlanilla = (id_usuario, datos) =>
    solicitudes.postRegistroAuth(`/planilla/crear/${id_usuario}`, datos);

export const marcarPagadoPlanilla = (id_planilla) =>
    solicitudes.patchRegistroAuth(`/planilla/pagar/${id_planilla}`, {});

export const generarPlanillaMensual = (id_usuario, datos) =>
    solicitudes.postRegistroAuth(`/planilla/generar/${id_usuario}`, datos);

export const eliminarPagoPlanilla = async (id_planilla, id_usuario) => {
    const { getApi } = await import('../config/getApiUrl');
    const token = localStorage.getItem('auth');
    const res = await fetch(`${getApi()}/planilla/${id_planilla}/${id_usuario}`, {
        method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` }
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || `Error ${res.status}`);
    return data;
};

// ─── PDF DOWNLOADS ───────────────────────────────────────────
const fetchPdfBlob = async (path) => {
    const token = localStorage.getItem('auth');
    const res = await fetch(`${getApi()}${path}`, { headers: { 'Authorization': `Bearer ${token}` } });
    if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(d.error || `Error ${res.status}`); }
    return res.blob();
};

const abrirPDF = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = filename; a.click();
    setTimeout(() => URL.revokeObjectURL(url), 10000);
};

export const descargarPDFDevolucion = async (id_devolucion) => {
    const blob = await fetchPdfBlob(`/devoluciones/pdf/${id_devolucion}`);
    abrirPDF(blob, `NC-${id_devolucion}.pdf`);
};

export const descargarPDFCotizacion = async (id_cotizacion) => {
    const blob = await fetchPdfBlob(`/cotizaciones/pdf/${id_cotizacion}`);
    abrirPDF(blob, `cotizacion-${id_cotizacion}.pdf`);
};

export const descargarPDFLibroVentas = async (id_usuario, fi, ff, id_sucursal = null) => {
    let qs = `?fecha_inicio=${fi}&fecha_fin=${ff}`;
    if (id_sucursal) qs += `&id_sucursal=${id_sucursal}`;
    const blob = await fetchPdfBlob(`/libros-fiscales/ventas/pdf/${id_usuario}${qs}`);
    abrirPDF(blob, `libro-ventas-${fi}-${ff}.pdf`);
};

export const descargarPDFLibroCompras = async (id_usuario, fi, ff, id_sucursal = null) => {
    let qs = `?fecha_inicio=${fi}&fecha_fin=${ff}`;
    if (id_sucursal) qs += `&id_sucursal=${id_sucursal}`;
    const blob = await fetchPdfBlob(`/libros-fiscales/compras/pdf/${id_usuario}${qs}`);
    abrirPDF(blob, `libro-compras-${fi}-${ff}.pdf`);
};

// ─── LIBROS FISCALES ─────────────────────────────────────────
export const getLibroVentas = (id_usuario, fi, ff, id_sucursal = null) => {
    let qs = `?fecha_inicio=${fi}&fecha_fin=${ff}`;
    if (id_sucursal) qs += `&id_sucursal=${id_sucursal}`;
    return solicitudes.fetchRegistrosAuth(`/libros-fiscales/ventas/${id_usuario}${qs}`);
};

export const getLibroCompras = (id_usuario, fi, ff, id_sucursal = null) => {
    let qs = `?fecha_inicio=${fi}&fecha_fin=${ff}`;
    if (id_sucursal) qs += `&id_sucursal=${id_sucursal}`;
    return solicitudes.fetchRegistrosAuth(`/libros-fiscales/compras/${id_usuario}${qs}`);
};

// ─── RECORDATORIOS ───────────────────────────────────────────
export const getCuentasVencidas = (id_usuario, dias = 7) =>
    solicitudes.fetchRegistrosAuth(`/recordatorios/vencidas/${id_usuario}?dias_anticipacion=${dias}`);

export const enviarRecordatorios = (id_usuario, datos) =>
    solicitudes.postRegistroAuth(`/recordatorios/enviar/${id_usuario}`, datos);

// ─── REPORTES AMPLIADOS ──────────────────────────────────────
export const getUtilidadBruta = (id_usuario, fi, ff, limite = 50) =>
    solicitudes.fetchRegistrosAuth(`/reporte/amp/utilidad/${id_usuario}/${fi}/${ff}?limite=${limite}`);

export const getRotacionInventario = (id_usuario, dias = 30, limite = 50) =>
    solicitudes.fetchRegistrosAuth(`/reporte/amp/rotacion/${id_usuario}?dias=${dias}&limite=${limite}`);

export const getComparativoMensual = (id_usuario, meses = 6) =>
    solicitudes.fetchRegistrosAuth(`/reporte/amp/comparativo/${id_usuario}?meses=${meses}`);

export const getProyeccionVentas = (id_usuario, dias_historico = 90, id_sucursal = null) => {
    let qs = `?dias_historico=${dias_historico}`;
    if (id_sucursal) qs += `&id_sucursal=${id_sucursal}`;
    return solicitudes.fetchRegistrosAuth(`/reporte/amp/proyeccion/${id_usuario}${qs}`);
};

export default {
    getVencimientos, actualizarVencimiento,
    registrarArqueo, getHistorialArqueo,
    getCotizaciones, crearCotizacion, getDetalleCotizacion, actualizarEstadoCotizacion,
    getDevoluciones, crearDevolucion, getItemsVenta, getRetornos, resolverRetorno, buscarNC, getHistorialNC,
    descargarPDFDevolucion, descargarPDFCotizacion, descargarPDFLibroVentas, descargarPDFLibroCompras,
    getNomina, getEmpleadosNomina, calcularNomina, marcarNominaPagada, previewNomina,
    getLibroVentas, getLibroCompras,
    getCuentasVencidas, enviarRecordatorios,
    getUtilidadBruta, getRotacionInventario, getComparativoMensual
};
